/* eslint-disable react-native/no-inline-styles */
import { CustomHeader, Screen, Text, TextInput } from "components"
import React, { useCallback, useEffect, useRef, useState } from "react"
import {
  ActivityIndicator,
  FlatList,
  Image,
  TouchableOpacity,
  View,
  useWindowDimensions,
} from "react-native"
import { useFocusEffect, useNavigation } from "@react-navigation/native"
import { style } from "./styles"
import { TabView } from "react-native-tab-view"
import { translate } from "i18n"
import LinearGradient from "react-native-linear-gradient"
import { colors } from "colors"
import Feather from "@expo/vector-icons/Feather"
import { useSessionExpired } from "utils/function"
import { useStores } from "models"
import flash from "config/flash"
import useResponsiveWidth from "components/fitSize"
import { filter } from "lodash"
import EmptyState from "components/EmptyState"
import { useColor } from "app/theme/getThemes"
import moment from "moment"

export const PromotionScreen = (props) => {
  const navigation = useNavigation<any>()
  const { companyTheme } = useColor()
  // const { width } = useWindowDimensions()

  const getResponsiveWidth = useResponsiveWidth()
  const { width } = getResponsiveWidth()

  const [index, setIndex] = useState(0)
  const [routes] = useState([
    { key: "first", title: "Promotions" },
    { key: "second", title: "News" },
  ])
  const [promotionPromotion, setPromotionPromotion] = useState([])
  const [memberPromotion, setMemberPromotion] = useState([])
  const [promotionList, setPromotionList] = useState([])
  const { sessionExpired } = useSessionExpired()
  const { userStore, couponStore } = useStores()
  const [loading, setLoading] = useState(false)
  const [isSearchVisible, setIsSearchVisible] = useState(false)
  const [searchText, setSearchText] = useState("")
  const searchTextRef = useRef()

  useEffect(() => {
    setLoading(true)
    getPromotion()
    getCoupon()
  }, [])

  const getCoupon = async () => {
    try {
      const res = await fetch(`${process.env.API_URL}/api/voucher/coupon/${userStore?.id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${userStore?.accessToken}`,
        },
      })

      if (res.ok) {
        const response = await res.json();
        const coupons = Array.isArray(response) ? response : [response];

        const firstVoucherForToday = coupons.find(coupon =>
          moment(coupon.start_date).isSame(moment(), 'day')
        );

        if (firstVoucherForToday) {
          const areIdsDifferent = firstVoucherForToday.voucher_catalog_id !== couponStore.newCouponNotifiedId;

          if (areIdsDifferent) {
            couponStore.setShowBadge(true);
            couponStore.setNewCouponNotifiedId(firstVoucherForToday.voucher_catalog_id);
          }
        }
      } else {
        console.log("Failed to call api");
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getPromotion = async () => {
    setLoading(true)
    await fetch(`${process.env.API_URL}/api/promotion/ongoing`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        setLoading(false)
        if (res?.ok) {
          const responseData = await res?.json()

          setPromotionList(responseData.filter((a: any) => a.status !== "inactive"))
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          } else {
            flash("error", translate("errors.failedToRetreivePromotion"))
          }
        }
      })
      .catch((e) => {
        setLoading(false)
        flash("error", translate("errors.failedToRetreivePromotion"))
        console.error(e)
      })
  }

  // use callback to prevent rerendering on switching tabs
  const FirstRoute = () => {
    const promoList = filter(promotionList, (e) => e?.promotion_type === "promotion")
    return (
      <Content
        data={
          searchText
            ? promoList?.filter((item) => item?.promotion_name.includes(searchText))
            : promoList
        }
      />
    )
  }
  const SecondRoute = () => {
    const newList = filter(promotionList, (e) => e?.promotion_type !== "promotion")
    return (
      <Content
        data={
          searchText
            ? newList?.filter((item) => item?.promotion_name.includes(searchText))
            : newList
        }
      />
    )
  }

  const Content = (data) => {
    return (
      <FlatList
        data={data?.data}
        contentContainerStyle={style.flex}
        numColumns={2}
        style={style.flatList}
        ListEmptyComponent={() => {
          return (
            <View
              style={{ marginTop: "10%", width: "100%", display: "flex", alignItems: "center" }}
            >
              <EmptyState />
            </View>
          )
        }}
        columnWrapperStyle={style.columnWrapper}
        renderItem={({ item }) => {
          return (
            <TouchableOpacity
              onPress={() => {
                navigation.navigate("promotionDetail", { promotion_id: item?.promotion_id })
              }}
              style={style.contentContainer}
            >
              <View>
                <Image
                  source={{ uri: item?.promotion_banner }}
                  style={[style.image, { width: width * 0.4, height: width * 0.4 }]}
                />
              </View>
              <View style={style.contentTitleText}>
                <Text numberOfLines={2}>{item?.promotion_name}</Text>
                {/* <Text style={style.contentDescription} numberOfLines={2}>
                  {item?.promotion_description}
                </Text> */}
                {/* <RenderHtml source={{ html: limitWords(item?.promotion_description || "", 5) }} /> */}
              </View>
            </TouchableOpacity>
          )
        }}
      />
    )
  }

  const navigationRoute = props.route.name

  return (
    <>
      <CustomHeader
        headerTitle={"Latest"}
        showBackButton={navigationRoute === "promotionHome" && true}
      />
      <Screen>
        <View style={style.container}>
          {isSearchVisible && (
            <LinearGradient
              style={{ paddingHorizontal: 20 }}
              colors={[companyTheme.first, companyTheme.second]}
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 0 }}
            >
              <TextInput
                textFieldContainer={{ borderRadius: 10 }}
                textFieldStyle={{ height: 40 }}
                autoFocus
                textRef={searchTextRef}
                rightIcon={() => (
                  <Feather
                    onPress={() => {
                      searchTextRef?.current && setSearchText(searchTextRef?.current?.value)
                    }}
                    name="search"
                    size={30}
                    color={companyTheme.first}
                  />
                )}
                onSubmitEditing={(e) => {
                  setSearchText(e?.nativeEvent?.text)
                }}
                placeholder={translate("promotionScreen.promotionName")}
              />
            </LinearGradient>
          )}
          <TabView
            swipeEnabled={false}
            animationEnabled={false}
            lazy
            renderTabBar={(props) => (
              <LinearGradient
                style={[style.linearGradient, { height: 60 }]}
                colors={[companyTheme.first, companyTheme.second]}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
              >
                <View style={style.headerTabBarContainer}>
                  {props.navigationState.routes.map((route, i) => {
                    return (
                      <TouchableOpacity
                        key={i}
                        onPress={() => setIndex(i)}
                        style={[style.tabBar, index === i && style.selectedTabBar]}
                      >
                        <Text
                          style={
                            index === i
                              ? { color: companyTheme.first, fontWeight: "bold" }
                              : { color: colors.white }
                          }
                        >
                          {route.title}
                        </Text>
                      </TouchableOpacity>
                    )
                  })}
                </View>
              </LinearGradient>
            )}
            navigationState={{ index, routes }}
            renderScene={({ route }) => {
              switch (route.key) {
                case "first":
                  return FirstRoute()
                default:
                  return SecondRoute()
              }
            }}
            onIndexChange={setIndex}
            initialLayout={{ width }}
          />
        </View>
      </Screen>
    </>
  )
}
